<template>
  <section class="search-main ">
    <div class="container-2">
      <div class="search-main__search-input">
        <input
          type="text"
          :placeholder="_.get(contentData, 'conf.header.title')"
          class="f-roman"
          v-model="search"
          @keyup.enter="searchRequers(search)"
        />
      </div>
      <div class="search-main__search-list" v-if="searchData.length">
        <div class="item" v-for="(item, index) in searchData" :key="index">
          <router-link :to="_.get(item, 'url')">
            <p class="ttl underline font-21 f-roman">{{ item.title }}</p>
          </router-link>
          <p class="desc font-16 f-roman" v-html="item.val"></p>
        </div>
      </div>
      <div class="not-found" v-if="!searchData.length && searchClicked">
        <h3 class="font-34 f-bold">
          {{ $fn.tr('nothing found') }}
        </h3>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ['contentData'],
  data() {
    return {
      search: '',
      searchClicked: false,
      searchData: [],
    };
  },
  watch: {
    search: {
      handler(val) {
        if (val?.length > 3) {
          setTimeout(() => {
            this.searchRequers(val);
          }, 300);
        }
      },
    },
  },
  methods: {
    search_in_menus(id) {
      let menus = this.$store.state.main.indx.menus;
      let _menu = {};
      menus = menus.filter((menu) => menu.secondary_data);
      for (let j = 0; j < menus.length; j++) {
        let secondary_data = menus[j].secondary_data.filter(
          (sec) => sec.page && sec.page.length !== 0
        );
        for (let k = 0; k < secondary_data.length; k++) {
          if (secondary_data[k].page.includes(id) && secondary_data[k].page.length == 1) {
            _menu.link = menus[j].full_url;
            _menu.titles = menus[j].titles;
            _menu.full = menus[j];
          }
        }
      }

      return _menu.link;
      // this.$router.push(_menu.link);
    },
    async searchRequers(val) {
      let menus = this.$store.state.main.indx.menus;
      var finalRes = [];

      let formData = {};
      formData.searchWord = val;
      this.searchClicked = true;
      let tmp = await this.$fn.postData('main/search', formData);

      for (let i in _.get(tmp, 'data.content')) {
        tmp.data.content[i].url = this.search_in_menus(tmp.data.content[i]?.id);
        if (!tmp.data.content[i].url)
          tmp.data.content[i].url = this.$store.getters['main/getSingleUrl'](tmp.data.content[i]);
      }

      this.searchData = tmp.data.content;
      this.searchData.forEach(function(item) {
        let _menu = {};
        menus = menus.filter((menu) => menu.secondary_data);
        for (let j = 0; j < menus.length; j++) {
          let secondary_data = menus[j].secondary_data.filter(
            (sec) => sec.page && sec.page.length !== 0
          );
          for (let k = 0; k < secondary_data.length; k++) {
            if (secondary_data[k].page.includes(item.id) && secondary_data[k].page.length == 1) {
              _menu.link = menus[j].full_url;
              _menu.titles = menus[j].titles;
              _menu.full = menus[j];
            }
          }
        }

        if (_menu.link !== undefined) {
          finalRes.push(item);
        }
      });
      // this.searchData = finalRes;
      return true;
    },
  },
};
</script>

<style lang="scss">
.search-main {
  padding-top: 89px;
  padding-bottom: 89px;
  background: var(--gray-bg);
  &__search-input {
    position: relative;

    height: 80px;
    margin-bottom: 40px;
    background: var(--white-bg);
    input {
      top: 0;
      left: 56px;
      right: 56px;
      height: 100%;
      font-size: 21px;
      position: absolute;
      color: var(--bonus-txt);
      width: calc(100% - 112px);
      background: var(--white-bg);
    }
    &::after {
      top: 50%;
      left: 32px;
      width: 2px;
      content: '';
      height: 25px;
      position: absolute;
      border-radius: 5px;
      background: var(--red);
      transform: translateY(-50%);
    }
  }
  &__search-list {
    .item {
      a {
        display: inline-flex;
      }
      border-bottom: 1px solid #f0f1f1;
      padding-bottom: 35px;
      margin-bottom: 56px;
      &:first-child {
        margin-top: 60px;
      }
      &:last-child {
        margin-bottom: 0px;
      }
      .ttl {
        color: var(--white-no-blue2);
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        -o-box-orient: vertical;
        -o-line-clamp: 2;
        -moz-box-orient: vertical;
        -moz-line-clamp: 2;
        -ms-box-orient: vertical;
        -ms-line-clamp: 2;
      }
      .date {
        margin-top: 17px;
        color: var(--red-txt);
      }
      .desc {
        line-height: 31px;
        margin-top: 30px;
        color: var(--white-no-blue2);
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        span {
          background: var(--secondary);
        }
      }
      button {
        margin-top: 27px;
        @include defBut(
          var(--primay-button-bg),
          var(--bonus-txt3),
          var(--secondarty-transparent),
          var(--white-button-txt2)
        );
      }
    }
  }
  .not-found {
    h3 {
      text-align: center;
    }
  }
}
</style>
